import { render, staticRenderFns } from "./NewDatatable.vue?vue&type=template&id=3c782dd0&scoped=true"
import script from "./NewDatatable.vue?vue&type=script&lang=js"
export * from "./NewDatatable.vue?vue&type=script&lang=js"
import style0 from "./NewDatatable.vue?vue&type=style&index=0&id=3c782dd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c782dd0",
  null
  
)

export default component.exports